import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import { COOKIE_AUTH_SIGNUP_MODAL, SignupModal } from "./signup-modal";

export const COOKIE_AUTH_SIGNUP = "auth_signup";

export const SignupCompleteHandler = () => {
  const [signupModal, signupModalSet] = useState(false);
  const isLoggedIn = useAppSelector(authNewSelectors.loggedInGet);
  const { pathname } = useLocation();

  useEffect(() => {
    const cookie = Cookies.get(COOKIE_AUTH_SIGNUP);
    const cookieModal = Cookies.get(COOKIE_AUTH_SIGNUP_MODAL);

    if (isLoggedIn && cookie === "true") {
      gtag("event", "conversion", {
        send_to: "AW-628742304/9UKHCLrQhcoZEKCx56sC",
      });
      Cookies.set(COOKIE_AUTH_SIGNUP_MODAL, "true", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        expires: 7,
      });
      signupModalSet(true);
    }

    if (isLoggedIn && cookieModal === "true") {
      signupModalSet(true);
    }

    Cookies.remove(COOKIE_AUTH_SIGNUP, {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    });
  }, [isLoggedIn]);

  const pathnameExcluded =
    pathname.startsWith("/purchase") || pathname.startsWith("/auth/invites");

  return (
    <>
      {!pathnameExcluded && signupModal && (
        <SignupModal onClose={() => signupModalSet(false)} />
      )}
    </>
  );
};
